import { TAdminSupplementInquiryStatus } from './adminSupplements';
import {
  IUserEnteredMedicationImagesResponseDto,
  TAdminMedicationResponseType,
} from './medications';

export interface IAdminMedicationInquiryDetailsDto {
  adminSupplementInquiryStatusId: number;
  medicationInquiryId: number;
  name: string;
  needsAdminResponse: boolean;
  respondedOn: string;
  submittedOn: string;
  supplementInquiryStatusId: number;
}

export interface IAdminMedicationInquiryDetailsEntry extends IAdminMedicationInquiryDetailsDto {
  entryInquiryId: number;
  isMedication: boolean;
}

export enum TMedicationResponseMode {
  ConfirmMedication,
  NeedMoreInfo,
}

export interface IAdminMedicationNeedsMoreInfoPayload {
  medicationInquiryId: number;
  comment: string;
}

export interface IAdminMedicationSubmitPayload {
  medicationInquiryId: number;
  medicationResponseId: number | null;
  comments: string;
}

export interface IAdminMedicationInquiryDetails {
  adminResponseType: TAdminMedicationResponseType | null;
  adminSupplementInquiryStatusId: TAdminSupplementInquiryStatus;
  comments: string | null;
  imageUrls: IUserEnteredMedicationImagesResponseDto[];
  lastUpdatedBy: string | null;
  lastUpdatedOn: string | null;
  medicationInquiryId: number;
  medicationResponseId: number | null;
  name: string;
  needsAdminResponse: boolean;
  organizationId: number;
  productLink: string | null;
  programCodeId: number;
  submittedOn: string;
  userEnteredMedicationId: number;
}
